import { Environment } from '../app/shared/env/environment.interface';

export const environment: Environment = {
  isLocalEnvironment: false,
  isDevEnvironment: false,
  authentication: true,
  production: true,
  trimAlias: false,
  tenantAdminId: 'bd76f856-43f7-4101-970e-30c00fbe0e08',
  OIDC_SETTINGS: {
    authority: 'https://login.microsoftonline.com/26b749f6-8c72-44e3-bbde-ae3de07b4206/v2.0',
    clientId: 'b88ad9c9-7036-49c8-8eaf-f875e6d37812',
    redirectUri: `${window.location.origin}/signin-callback`,
    scope: 'api://344c3b5b-752e-4455-9d43-67c85ecd4c5f/default openid profile email',
    silentRedirectUri: `${window.location.origin}/silent-callback`,
    postLogoutRedirectUri: `${window.location.origin}`,
  },
  MODEL_VIEWER_CONFIG: {
    modelViewerAuthBaseUrl: '/api/model3dprofiles/{profileId}/proxy',
    cdf_project: 'integral',
  },
  USERPILOT_CONFIG: {
    enabled: true,
  },
  TRACKING_CONFIG: {
    enabled: true,
    prefix: 'IEX',
    env: 'prod',
  },
};
